<template>
  <v-menu
    ref="menu"
    v-model="dateMenuVisible"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <slot :on="on">
        <v-text-field
          v-model="dateText"
          :label="label"
          :prepend-icon="icon"
          v-on="on"
          :hide-details="hideDetails"
          :rules="rules"
          v-bind="$attrs"
          :clearable="clearable"
          :style="inputStyle"
        />
      </slot>
    </template>

    <v-date-picker
      v-model="date"
      @input="dateMenuVisible = false"
      :range="range"
      no-title
      scrollable
      @change="onDateChanged"
    />
  </v-menu>
</template>

<script>
export default {
  props: {
    rules: {
      type: Array,
      default: undefined
    },

    value: {
      type: [String, Array],
      default: undefined
    },

    label: {
      type: String,
      default: "Date"
    },

    icon: {
      type: String,
      default: "event"
    },

    hideDetails: {
      type: Boolean,
      default: false
    },

    range: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: false
    },

    inputStyle: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      dateMenuVisible: false,

      dateTextData: "",

      innerChanged: false
    };
  },

  computed: {
    date: {
      get() {
        if (this.range && !this.value) {
          return [];
        }

        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    },

    dateText: {
      get() {
        return this.dateTextData;
      },
      set(val) {
        this.dateTextData = val;

        if (val && val.length >= 10 && !isNaN(new Date(val))) {
          this.innerChanged = true;
          this.date = new Date(val).toISOString().substring(0, 10);
        } else {
          this.date = undefined;
        }
      }
    }
  },

  watch: {
    value() {
      if (this.innerChanged) {
        this.innerChanged = false;
        return;
      }

      this.dateTextData = this.value;
    }
  },

  created() {
    this.dateTextData = this.value;
  },

  methods: {
    onDateChanged(val) {
      this.dateTextData = val;
    }
  }
};
</script>
